import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

type Props = {
  title: string;
  /** Renders the card body as a form when provided. */
  onSubmit?: (e: React.FormEvent) => void;
  maxWidth?: number;
  children: React.ReactNode;
};

/**
 * Centred card shell for the screens that sit outside the dashboard shell —
 * login, signup, and the states they hand off to.
 */
const AuthCard: React.FC<Props> = ({ title, onSubmit, maxWidth = 420, children }) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: 'background.default',
      p: 2,
    }}
  >
    <Paper
      variant="outlined"
      sx={{ p: { xs: 3, sm: 4 }, borderRadius: 2, width: '100%', maxWidth }}
    >
      <Stack
        component={onSubmit ? 'form' : 'div'}
        onSubmit={onSubmit}
        spacing={2.5}
      >
        <Typography variant="h5" component="h1" textAlign="center">
          {title}
        </Typography>
        {children}
      </Stack>
    </Paper>
  </Box>
);

export default AuthCard;
